export default "__VITE_PUBLIC_ASSET__cf0456c4__"